import { render, staticRenderFns } from "./tab-quarternary.vue?vue&type=template&id=4a0bdd07&scoped=true&"
import script from "./tab-quarternary.vue?vue&type=script&lang=js&"
export * from "./tab-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bdd07",
  null
  
)

export default component.exports